import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import GeometryComponentFilter from './GeometryComponentFilter';
import Comparable from '../../../../java/lang/Comparable';
import Cloneable from '../../../../java/lang/Cloneable';
import Serializable from '../../../../java/io/Serializable';
import Envelope from './Envelope';
var Geometry = /*#__PURE__*/function () {
  function Geometry() {
    _classCallCheck(this, Geometry);
    Geometry.constructor_.apply(this, arguments);
  }
  _createClass(Geometry, [{
    key: "isGeometryCollection",
    value: function isGeometryCollection() {
      return this.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION;
    }
  }, {
    key: "getFactory",
    value: function getFactory() {
      return this._factory;
    }
  }, {
    key: "getGeometryN",
    value: function getGeometryN(n) {
      return this;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      return 0.0;
    }
  }, {
    key: "isRectangle",
    value: function isRectangle() {
      return false;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact(other) {
      return this === other || this.equalsExact(other, 0);
    }
  }, {
    key: "geometryChanged",
    value: function geometryChanged() {
      this.apply(Geometry.geometryChangedFilter);
    }
  }, {
    key: "geometryChangedAction",
    value: function geometryChangedAction() {
      this._envelope = null;
    }
  }, {
    key: "equalsNorm",
    value: function equalsNorm(g) {
      if (g === null) return false;
      return this.norm().equalsExact(g.norm());
    }
  }, {
    key: "getLength",
    value: function getLength() {
      return 0.0;
    }
  }, {
    key: "getNumGeometries",
    value: function getNumGeometries() {
      return 1;
    }
  }, {
    key: "compareTo",
    value: function compareTo() {
      var other;
      if (arguments.length === 1) {
        var o = arguments[0];
        other = o;
        if (this.getTypeCode() !== other.getTypeCode()) return this.getTypeCode() - other.getTypeCode();
        if (this.isEmpty() && other.isEmpty()) return 0;
        if (this.isEmpty()) return -1;
        if (other.isEmpty()) return 1;
        return this.compareToSameClass(o);
      } else if (arguments.length === 2) {
        var _o = arguments[0];
        var comp = arguments[1];
        other = _o;
        if (this.getTypeCode() !== other.getTypeCode()) return this.getTypeCode() - other.getTypeCode();
        if (this.isEmpty() && other.isEmpty()) return 0;
        if (this.isEmpty()) return -1;
        if (other.isEmpty()) return 1;
        return this.compareToSameClass(_o, comp);
      }
    }
  }, {
    key: "getUserData",
    value: function getUserData() {
      return this._userData;
    }
  }, {
    key: "getSRID",
    value: function getSRID() {
      return this._SRID;
    }
  }, {
    key: "getEnvelope",
    value: function getEnvelope() {
      return this.getFactory().toGeometry(this.getEnvelopeInternal());
    }
  }, {
    key: "checkNotGeometryCollection",
    value: function checkNotGeometryCollection(g) {
      if (g.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION) throw new IllegalArgumentException('This method does not support GeometryCollection arguments');
    }
  }, {
    key: "equal",
    value: function equal(a, b, tolerance) {
      if (tolerance === 0) return a.equals(b);
      return a.distance(b) <= tolerance;
    }
  }, {
    key: "norm",
    value: function norm() {
      var copy = this.copy();
      copy.normalize();
      return copy;
    }
  }, {
    key: "reverse",
    value: function reverse() {
      var res = this.reverseInternal();
      if (this.envelope != null) res.envelope = this.envelope.copy();
      res.setSRID(this.getSRID());
      return res;
    }
  }, {
    key: "copy",
    value: function copy() {
      var copy = this.copyInternal();
      copy.envelope = this._envelope == null ? null : this._envelope.copy();
      copy._SRID = this._SRID;
      copy._userData = this._userData;
      return copy;
    }
  }, {
    key: "getPrecisionModel",
    value: function getPrecisionModel() {
      return this._factory.getPrecisionModel();
    }
  }, {
    key: "getEnvelopeInternal",
    value: function getEnvelopeInternal() {
      if (this._envelope === null) this._envelope = this.computeEnvelopeInternal();
      return new Envelope(this._envelope);
    }
  }, {
    key: "setSRID",
    value: function setSRID(SRID) {
      this._SRID = SRID;
    }
  }, {
    key: "setUserData",
    value: function setUserData(userData) {
      this._userData = userData;
    }
  }, {
    key: "compare",
    value: function compare(a, b) {
      var i = a.iterator();
      var j = b.iterator();
      while (i.hasNext() && j.hasNext()) {
        var aElement = i.next();
        var bElement = j.next();
        var comparison = aElement.compareTo(bElement);
        if (comparison !== 0) return comparison;
      }
      if (i.hasNext()) return 1;
      if (j.hasNext()) return -1;
      return 0;
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return this.getEnvelopeInternal().hashCode();
    }
  }, {
    key: "isEquivalentClass",
    value: function isEquivalentClass(other) {
      return this.getClass() === other.getClass();
    }
  }, {
    key: "isGeometryCollectionOrDerived",
    value: function isGeometryCollectionOrDerived() {
      if (this.getTypeCode() === Geometry.TYPECODE_GEOMETRYCOLLECTION || this.getTypeCode() === Geometry.TYPECODE_MULTIPOINT || this.getTypeCode() === Geometry.TYPECODE_MULTILINESTRING || this.getTypeCode() === Geometry.TYPECODE_MULTIPOLYGON) return true;
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return Geometry;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Cloneable, Comparable, Serializable];
    }
  }], [{
    key: "hasNonEmptyElements",
    value: function hasNonEmptyElements(geometries) {
      for (var i = 0; i < geometries.length; i++) if (!geometries[i].isEmpty()) return true;
      return false;
    }
  }, {
    key: "hasNullElements",
    value: function hasNullElements(array) {
      for (var i = 0; i < array.length; i++) if (array[i] === null) return true;
      return false;
    }
  }]);
  return Geometry;
}();
export { Geometry as default };
Geometry.constructor_ = function (factory) {
  if (!factory) return;
  this._envelope = null;
  this._userData = null;
  this._factory = factory;
  this._SRID = factory.getSRID();
};
Geometry.TYPECODE_POINT = 0;
Geometry.TYPECODE_MULTIPOINT = 1;
Geometry.TYPECODE_LINESTRING = 2;
Geometry.TYPECODE_LINEARRING = 3;
Geometry.TYPECODE_MULTILINESTRING = 4;
Geometry.TYPECODE_POLYGON = 5;
Geometry.TYPECODE_MULTIPOLYGON = 6;
Geometry.TYPECODE_GEOMETRYCOLLECTION = 7;
Geometry.TYPENAME_POINT = 'Point';
Geometry.TYPENAME_MULTIPOINT = 'MultiPoint';
Geometry.TYPENAME_LINESTRING = 'LineString';
Geometry.TYPENAME_LINEARRING = 'LinearRing';
Geometry.TYPENAME_MULTILINESTRING = 'MultiLineString';
Geometry.TYPENAME_POLYGON = 'Polygon';
Geometry.TYPENAME_MULTIPOLYGON = 'MultiPolygon';
Geometry.TYPENAME_GEOMETRYCOLLECTION = 'GeometryCollection';
Geometry.geometryChangedFilter = {
  get interfaces_() {
    return [GeometryComponentFilter];
  },
  filter: function filter(geom) {
    geom.geometryChangedAction();
  }
};